import classnames from "classnames";
import map from "lodash/map";
import round from "lodash/round";
import React from "react";

import { formatCurrency } from "../../../../util/formatHelpers";
import { PERCENTAGE_OF_COMPENSATION, PERCENTAGE_RANGE } from "../../../forms/formik/FormikFeeOptions/fieldHelpers";
import PopoverLink from "../../../General/PopoverLink";
import OptimizedRatesIcon from "../../../shared/Icons/OptimizedRatesIcon";

import { useStyles, RFI_OPTIMIZED_FEE_OPTION } from "./constants";

export function renderOptimizedRatesIcon() {
  return (
    <PopoverLink
      renderLink={(handleClick, _isSelected) => (
        <span role="button" onClick={handleClick} onMouseEnter={handleClick}>
          <OptimizedRatesIcon style={{ fontSize: 28 }} />
        </span>
      )}
      renderPopoverContent={(handleClick) => (
        <div
          data-cy="fee-tooltip-content"
          style={{ padding: "6px 8px", fontSize: 16 }}
          onMouseLeave={handleClick}
        >
          <a
            href="https://help.recruitifi.com/en/articles/5485229-what-is-the-recruitifi-optimized-fee-and-how-does-it-work"
            target="_blank"
            rel="noopener noreferrer"
          >
            RecruitiFi Optimized Fee
          </a>
        </div>
      )}
    />
  );
}

function FeeSection({ title = null, feeData = [], placeholderNote = "For all hires" }) {
  const classes = useStyles();

  const renderFeeOptions = () => {
    const renderFeeContent = (feeOption) => {
      if (feeOption === RFI_OPTIMIZED_FEE_OPTION) {
        return (
          <a
            href="https://help.recruitifi.com/en/articles/5485229-what-is-the-recruitifi-optimized-fee-and-how-does-it-work"
            target="_blank"
            rel="noopener noreferrer"
            className={classnames(classes.valueContainer, "subtitle-2")}
            style={{ display: "flex", alignItems: "center", border: "0px" }}
          >
            <OptimizedRatesIcon style={{ fontSize: 28, marginRight: "8px" }} />
            <div className={`${classes.linkText} small`}>
              RecruitiFi Optimized Fee
            </div>
          </a>
        );
      }

      if (typeof feeOption === "string") {
        return (
          <div className="subtitle-2">
            {feeOption}
          </div>
        );
      }

      const renderFeeRate = () => {
        if (feeOption.feeType === PERCENTAGE_OF_COMPENSATION) {
          return `${round(feeOption.feePercentage * 100, 2)}%`;
        } if (feeOption.feeType === PERCENTAGE_RANGE) {
          return `${round(feeOption.feePercentage * 100, 2)}% - ${round(feeOption.feePercentageMax * 100, 2)}%`;
        }
        return `${formatCurrency(feeOption.feeCents, feeOption.currency, {
          precision: 2,
        }).replace(/\.?0+$/, "")}`;
      };

      return (
        <>
          <div className={classnames(classes.valueContainer, "subtitle-2")}>
            {renderFeeRate()}
          </div>
          <div className="small">
            {feeOption.note || placeholderNote}
          </div>
        </>
      );
    };

    return map(feeData, (fee, index) => (
      <div key={index} className={classes.feeOption}>
        {renderFeeContent(fee)}
      </div>
    ));
  };

  return (
    <div className={classes.feeSection}>
      {title && (
        <div className={classnames("overline-heading", classes.header)}>
          {title}
        </div>
      )}
      {renderFeeOptions()}
    </div>
  );
}

export default FeeSection;
